import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import HSCodeClassificationPage from './HSCodeClassificationPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

function WrappedHSCodeClassificationPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <HSCodeClassificationPage showNotification={showSnackbar} {...props} />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedHSCodeClassificationPage as HSCodeClassificationPage
}
